import React from 'react';
import css from './EditListingWizardButtons.module.css';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Button } from '../../components';

const EditListingWizardButtons = (props) => {

  const {
    intl,
    disabled,
    inProgress,
    ready,
    saveActionMsg,
    isClient,
    isNewListingFlow,
    isPhotosTab,
    isPostsTab,
    isDescriptionTab,
    isDraftListing,
    onHandlePreviewPopup,
    listingData,
    listing,
    values,
    imagesArray,
    invalidValues,
    onHandleValidatonPopup,
    onHandleCreateAndBublishListing,
    publishSuccess,
    isOffer,
    isStartupOffer,
  } = props;

  const draft = isNewListingFlow || isDraftListing;

  if (isOffer || isStartupOffer) {

    return (
      <div className={css.buttonsBlock}>

        {!!invalidValues?.length ? (
          <Button
            className={css.submitButton}
            type="button"
            inProgress={inProgress}
            ready={ready}
            onClick={() => onHandleValidatonPopup(true, invalidValues)}
          >
            {saveActionMsg}
          </Button>
        ) : isNewListingFlow ? (
          <Button
            className={css.submitButton}
            type="button"
            disabled={disabled}
            ready={publishSuccess}
            onClick={() => onHandleCreateAndBublishListing(values, imagesArray, listing, false, true)}
          >
            <FormattedMessage id="EditListingPage.publish" />
          </Button>
        ) : (
          <Button
            className={css.submitButton}
            type="submit"
            inProgress={inProgress}
            disabled={disabled}
            ready={ready}
          >
            {saveActionMsg}
          </Button>
        )}
      </div>
    )

  } else {
    return (
      <div className={css.buttonsBlock}>
        {!!invalidValues?.length ? (
          <Button
            className={css.submitButton}
            type="button"
            inProgress={inProgress}
            ready={ready}
            onClick={() => onHandleValidatonPopup(true, invalidValues)}
          >
            {saveActionMsg}
          </Button>
        ) : (
          <Button
            className={css.submitButton}
            type="submit"
            inProgress={inProgress}
            disabled={disabled}
            ready={ready}
          >
            {saveActionMsg}
          </Button>
        )}

        <Button
          className={css.submitButton}
          type="button"
          onClick={() => onHandlePreviewPopup(true, listingData, { values, imagesArray, listing, isDescriptionTab })}
        >
          <FormattedMessage id="EditListingPage.preview" />
        </Button>

        {draft && isClient && !isPhotosTab &&
          (!!invalidValues?.length ? (
            <Button
              className={css.submitButton}
              type="button"
              disabled={disabled}
              ready={publishSuccess}
              onClick={() => onHandleValidatonPopup(true, invalidValues)}
            >
              <FormattedMessage id="EditListingPage.publish" />
            </Button>
          ) : (
            <Button
              className={css.submitButton}
              type="button"
              disabled={disabled}
              ready={publishSuccess}
              onClick={() => onHandleCreateAndBublishListing(values, imagesArray, listing, isDescriptionTab)}
            >
              <FormattedMessage id="EditListingPage.publish" />
            </Button>
          ))}

        {draft && !isClient && !isPostsTab &&
          (!!invalidValues?.length ? (
            <Button
              className={css.submitButton}
              type="button"
              disabled={disabled}
              ready={publishSuccess}
              onClick={() => onHandleValidatonPopup(true, invalidValues)}
            >
              <FormattedMessage id="EditListingPage.publish" />
            </Button>
          ) : (
            <Button
              className={css.submitButton}
              type="button"
              disabled={disabled}
              ready={publishSuccess}
              onClick={() => onHandleCreateAndBublishListing(values, imagesArray, listing, isDescriptionTab)}
            >
              <FormattedMessage id="EditListingPage.publish" />
            </Button>
          ))}
      </div>
    );
  }

}

export default injectIntl(EditListingWizardButtons);
